import React from 'react'
import { Link, Stack, Box, Text } from '@chakra-ui/react'
import Image from 'next/legacy/image'

export const Partners = (props: any) => {
  return (
    <Box
      w='full'
      overflow='hidden'
      mt={8}
      p={4}
      sx={{
        scrollbarWidth: 'none',
        '::-webkit-scrollbar': { display: 'none' },
      }}>
      <Text textAlign='center' mb={4} textTransform='uppercase'>
        <Link href='/partners'>{props.heading || 'Our Amazing Partners'}</Link>
      </Text>
      <Stack
        spacing={12}
        direction='row'
        flexWrap='wrap'
        justifyContent='center'>
        {props.partners.map((data: any) =>
          data.logo ? (
            <Box
              key={data.id}
              className={`js-partners-item item-${data.id}`}
              m='0'
              py='0'>
              <Link
                position='relative'
                w={`${data.logo.width / (data.logo.height / 40)}px`}
                display='block'
                href={data.website}
                sx={{
                  filter: 'grayscale(100%)',
                  _hover: { filter: 'grayscale(0%)' },
                }}
                overflow='hidden'>
                <Image
                  src={data.logo.url}
                  height='160'
                  width={data.logo.width / (data.logo.height / 160)}
                  objectFit='contain'
                  objectPosition='center center'
                  alt={data.slug}
                />
              </Link>
            </Box>
          ) : null
        )}
      </Stack>
    </Box>
  )
}
